import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ExitMeetingPageComponent } from './exit-meeting-page.component';

const states: Ng2StateDeclaration[] = [
  {
    name: 'exitMeeting',
    url: '/exitMeeting',
    component: ExitMeetingPageComponent,
    data: {
      requireLogin: false
    }
  }
];

@NgModule({
  declarations: [ExitMeetingPageComponent],
  imports: [
    CommonModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ExitMeetingPageComponent],
})
export class ExitMeetingPageModule { }
